import { makeActionCreator } from '../../../utilities'
import { BillingConstants } from './billing.constants'

export const setSelectedOption = makeActionCreator(BillingConstants.SET_SELECTED_OPTION, 'selectedOption')
export const refreshBillingData = makeActionCreator(BillingConstants.REFRESH_BILLING_DATA)
